import React, { FunctionComponent } from "react";
import AboutBlock from "../../blocks/aboutBlock";
import FarewellBlock from "../../blocks/farewellBlock";
import FeaturesBlock from "../../blocks/featuresBlock";
import GreetingBlock from "../../blocks/greetingBlock";
import PriceBlock from "../../blocks/priceBlock";
import "./style.scss";

const MainPage: FunctionComponent = () => {
    return <div className="MainPage">
        <GreetingBlock />

        <PriceBlock />

        <FeaturesBlock />

        <AboutBlock />

        <FarewellBlock />
    </div>
}

export default MainPage;